import { ProductRouteType } from '@/creditflowresearch/domain/Product/types/ProductRouteType';
import { ABS_PATH_PATTERNS, CORPORATE_PATH_PATTERNS } from '@/creditflowresearch/domain/Product/infrastructure/constants';

const matchesAnyPath = (pathname: string, patterns: readonly string[]): boolean => {
  return patterns.some((pattern) => pathname.includes(pattern));
};

const routePatterns = [
  { patterns: ABS_PATH_PATTERNS, type: ProductRouteType.ABS },
  { patterns: CORPORATE_PATH_PATTERNS, type: ProductRouteType.CORPORATE },
] as const;

export const detectProductRouteType = (pathname: string): ProductRouteType => {
  const matchedRoute = routePatterns.find(({ patterns }) => matchesAnyPath(pathname, patterns));
  return matchedRoute?.type || ProductRouteType.OTHER;
};
